import { useState, useEffect } from "react";
import {
  Group,
  Textarea,
  Loader,
  rem,
  Button,
  Center,
  MultiSelect,
  Badge,
  Title,
  Switch,
} from "@mantine/core";
import { IconSend } from "@tabler/icons-react";
import { sendLlmMessagesBulk } from "./bulkApi";
import { useStore } from "../../store";
import ModelMultiSelect from "../../_Common/ModelMultiSelect";
import { useBulkStore } from "./store";
import useToolStore from "../../Tools/toolStore";

export default function PlaygroundBulkEditor() {
  const activeTemplate = useStore((state) => state.activeTemplate);
  const [isThinking, setIsThinking] = useState(false);
  const [textareaText, setTextareaText] = useState("");
  const [selectedModels, setSelectedModels] = useState([]);
  const [showAdvancedOptions, setShowAdvancedOptions] = useState(false);

  const [selectedVendorTools, setSelectedVendorTools] = useState([]);
  const [selectedTools, setSelectedTools] = useState([]);

  const { addBulkCall } = useBulkStore();
  const vendorTools = [{ label: "Search", value: "search" }];

  const { fetchTools, tools } = useToolStore();

  useEffect(() => {
    if (tools?.length === 0) {
      fetchTools();
    }
  }, [fetchTools, tools?.length]);
  const supportedTools =
    tools?.map((p) => ({ label: p.name, value: p.id })) ?? [];

  useEffect(() => {
    setTextareaText(activeTemplate);
  }, [activeTemplate]);

  function sendMessage() {
    setIsThinking(true);
    const msg = {
      message: textareaText,
      models: selectedModels,
      mode: "bulk",
      vendorTools: selectedVendorTools,
      tools: selectedTools,
      // temperature: temperature,
    };

    sendLlmMessagesBulk(msg)
      .then((response) => {
        addBulkCall(response.call);

        setIsThinking(false);
        setTextareaText("");
      })
      .catch((error) => {
        console.error(error);
        setIsThinking(false);
        setTextareaText(msg.text);
      });
  }

  return (
    <>
      <Group justify="space-between">
        <Title>Prompt Playground</Title>
        <Switch
          checked={showAdvancedOptions}
          onChange={(e) => setShowAdvancedOptions(e.currentTarget.checked)}
          label="Show advanced options"
        />
      </Group>
      <Textarea
        placeholder="Enter your prompt"
        autosize
        minRows={5}
        maxRows={25}
        radius="md"
        size="md"
        onChange={(event) => setTextareaText(event.currentTarget.value)}
        value={textareaText}
        style={{ flex: "1" }}
      />

      <ModelMultiSelect
        value={selectedModels}
        onChange={setSelectedModels}
        description="Select all models to send this request to"
        placeholder="Pick models"
      />

      {showAdvancedOptions && (
        <Group mt="xs">
          <MultiSelect
            data={vendorTools || []}
            description="LLM provider tools to be used with this call"
            label="Vendor Tools"
            searchable
            style={{ flex: 1 }}
            value={selectedVendorTools}
            onChange={setSelectedVendorTools}
          />

          <MultiSelect
            data={supportedTools || []}
            description="Custom tools to be used with this call"
            label={
              <>
                Tools{" "}
                <Badge color="red" variant="light" size="xs">
                  Preview
                </Badge>
              </>
            }
            searchable
            style={{ flex: 1 }}
            value={selectedTools}
            onChange={setSelectedTools}
          />
        </Group>
      )}

      {/* 
      <Text size="sm" mt="xl">
        Temperature
      </Text>
      <Slider
        onChange={setTemperature}
        value={temperature}
        min={0.0}
        max={1.0}
        label={(value) => value.toFixed(2)}
        step={0.01}
        color="blue"
        marks={[
          { value: 0.2, label: "0.2" },
          { value: 0.5, label: "0.5" },
          { value: 0.8, label: "0.8" },
        ]}
      /> */}

      <Group justify="flex-end">
        <Button
          mt="lg"
          rightSection={
            <IconSend
              style={{ width: rem(18), height: rem(18) }}
              stroke={1.8}
            />
          }
          onClick={() => sendMessage()}
          disabled={isThinking || textareaText === ""}
        >
          Send
        </Button>
      </Group>

      {isThinking && (
        <Center>
          <Loader style={{ alignSelf: "center" }} mt="xl" size="xl" />
        </Center>
      )}
    </>
  );
}
